<!--
 * @Descripttion: 
 * @Author: py
 * @Date: 2021-03-29 15:51:57
 * @LastEditors: ChaoLuanDi
 * @LastEditTime: 2021-05-20 10:44:46
-->
<template>
  <el-dialog title="删除" width="410px" :visible.sync="dialogVisible" class="uploadbox">
    <div class="dialog-content">
      <img class="tips-icon" src="../../../assets/img/icon_warning.png" width="32" alt="" />
      有{{ lennum }}个文件待上传，是否取消上传
    </div>
    <div class="dialog-footer">
      <el-button size="mini" round @click="cancelUpload">取消上传</el-button>
      <el-button type="primary" size="mini" round @click="dialogVisible = false">继续上传</el-button>
    </div>
  </el-dialog>
</template>
<script>
// import { number } from "echarts";
export default {
  name: "UploadFolder",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    lennum: {
      type: Number,
      delete: 0,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    cancelUpload() {
      this.dialogVisible = false;
      this.$emit("cancelUpload");
    },
  },
};
</script>
<style scoped lang="less">
.dialog-content {
  font-size: 16px;
  color: #555;
  text-align: center;
  margin-bottom: 30px;
  .tips-icon {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.dialog-footer {
  text-align: center;
  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 35px;
  }
}
::v-deep .el-dialog__body{
  padding: 30px!important;
}
</style>
